import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { ClickEventNumbersEnum, TrackingPayloadType } from 'src/app/interfaces/clickEventNumbers';

@Injectable({
  providedIn: 'root',
})
export class ClickTrackerService {
  private apiUrl = `${environment.apiUrl}/api/tracking/event`;

  constructor(private http: HttpClient) {}

  sendPayload(payload: TrackingPayloadType): void {
    this.http.post(this.apiUrl, payload).subscribe({
      next: () => {
        // No action for successful response
      },
      error: (error) => {
        console.error('Error sending payload:', error);
      },
    });
  }

  handleButtonClick(eventNumber: ClickEventNumbersEnum, details: string) {
    const payload = {
      event: eventNumber,
      details,
    };
    this.sendPayload(payload);
  }
}
